import { gql } from "@apollo/client";

export default gql`
  query routines {
    routines {
      id
      name
      skillId
      skillSlug
      enabled
      triggerType
      triggerConfig
      skillExists
      selectedMeetingGroups {
        id
        title
      }
    }
  }
`;
